import { PRINTER_ILLUSTRATION } from "@/config/assets";
import { DTF_PRINT_WIDTH } from "@/config/dtf";
import { formatNum } from "@/lib/dtf";

const Art = ({ variant }) => {
  if (variant === 0)
    return (
      <div className="flex h-[54px] items-center justify-center gap-2 px-3">
        <span className="h-[40px] w-[40%] rounded-[3px] bg-[#f58244]" />
        <span className="h-[40px] w-[40%] rounded-[3px] bg-white/85" />
      </div>
    );
  if (variant === 1)
    return (
      <div className="flex h-[54px] items-center justify-center gap-2 px-3">
        <span className="h-[40px] w-[26%] rounded-full bg-white/75" />
        <span className="h-[40px] w-[52%] rounded-[3px] bg-[#f58244]/85" />
      </div>
    );
  return (
    <div className="flex h-[54px] items-center justify-center gap-2 px-3">
      <span className="h-[40px] w-[84%] rounded-[3px] bg-[#f58244]/60" />
    </div>
  );
};

const Strip = ({ prefix }) => (
  <>
    {[0, 1, 2, 0, 1].map((v, i) => (
      <Art key={`${prefix}-${i}`} variant={v} />
    ))}
  </>
);

export const PrinterAnimation = () => (
  <div className="grain relative overflow-hidden rounded-[28px] border border-neutral-200 bg-[#f6f6f5] pt-5">
    <p className="num relative z-20 px-6 text-[10px] uppercase tracking-[0.3em] text-neutral-400">
      Impressão DTF têxtil / filme saindo
    </p>

    {/* corpo da impressora (topo e pés recortados) */}
    <div className="relative mt-2 h-[190px] w-full overflow-hidden">
      <img
        src={PRINTER_ILLUSTRATION}
        alt="Ilustração de uma impressora DTF têxtil imprimindo filme com estampas"
        className="pointer-events-none absolute left-1/2 top-[-26%] w-[104%] -translate-x-1/2 select-none"
        loading="eager"
      />
    </div>

    {/* filme saindo */}
    <div className="relative z-10 mx-auto -mt-1 h-[150px] w-[44%] overflow-hidden bg-[#141414] shadow-[0_18px_28px_-20px_rgba(0,0,0,0.8)]">
      <div className="film-feed">
        <Strip prefix="a" />
        <Strip prefix="b" />
      </div>
      <div className="pointer-events-none absolute inset-x-0 top-0 h-6 bg-gradient-to-b from-black/80 to-transparent" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-[#f6f6f5] via-[#f6f6f5]/80 to-transparent" />
    </div>

    <div className="relative z-20 mt-2 flex items-end gap-10 border-t border-neutral-200 bg-white/70 px-6 py-5 backdrop-blur">
      <div>
        <p className="num text-2xl font-semibold leading-none text-black">
          {formatNum(DTF_PRINT_WIDTH, 0)}
          <span className="text-sm text-neutral-400"> cm</span>
        </p>
        <p className="mt-1 text-xs text-neutral-500">largura útil</p>
      </div>
      <span className="h-8 w-px bg-neutral-200" />
      <div>
        <p className="num text-2xl font-semibold leading-none text-black">100%</p>
        <p className="mt-1 text-xs text-neutral-500">grátis, sem login</p>
      </div>
    </div>
  </div>
);
